const validateOnlyBlank = ({ name, description }: { name?: string; description?: string }) => {
    const isNameNotBlank = name && String(name).trim().length > 0;
    const isDescriptionNotBlank = description ? String(description).trim().length > 0 : true;
    return isNameNotBlank && isDescriptionNotBlank;
};

export { validateOnlyBlank };
